/* eslint-disable react-refresh/only-export-components */
import React from "react";

export const NestedContext = React.createContext<boolean | undefined>(
  undefined,
);
export const NestedProvider = NestedContext.Provider;
export const useNested = () => React.useContext(NestedContext);
